module.exports = __webpack_public_path__ + "media/images/uva-1-24c0b1b450c5e8cfb2eeac62ec291936.jpg";